var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrgCount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58735 2.96875H12.4974C12.7733 2.96875 12.9971 3.19248 12.9971 3.46846V14.462C12.9971 14.738 12.7733 14.9617 12.4974 14.9617H3.50267C3.22669 14.9617 3.00296 14.738 3.00296 14.462V3.46846C3.00296 3.19248 3.22669 2.96875 3.50267 2.96875H6.45697",
    stroke: "#051b46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9998 11.5133C9.10372 11.5133 9.99862 10.6184 9.99862 9.51445C9.99862 8.41053 9.10372 7.51562 7.9998 7.51562C6.89588 7.51562 6.00098 8.41053 6.00098 9.51445C6.00098 10.6184 6.89588 11.5133 7.9998 11.5133Z",
    stroke: "#051b46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00146 13.0108C5.35056 12.5454 5.80323 12.1676 6.32363 11.9074C6.84404 11.6472 7.41787 11.5117 7.9997 11.5117C8.58152 11.5117 9.15536 11.6472 9.67576 11.9074C10.1962 12.1676 10.6488 12.5454 10.9979 13.0108",
    stroke: "#051b46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88175 1.03516H9.1174L9.11757 4.22548H6.88192L6.88175 1.03516Z",
    stroke: "#051b46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8819 5.58594L9.11769 5.58594",
    stroke: "#051b46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgCount);
export default __webpack_public_path__ + "static/media/orgCount.aa9d782788a247d1e5fac981ef4d9caf.svg";
export { ForwardRef as ReactComponent };